import { createReducer, on } from '@ngrx/store';

import {
    DeliveryNote,
    DeliveryNotesOverview,
  } from 'src/app/uig-my-account/delivery-notes/delivery-notes.models';

  import * as DeliveryNotesActions from './delivery-notes.actions';
  
  export const deliveryNotesFeatureKey = 'deliveryNotes';

  export const marketplaceDeliveryNotesFeatureKey = 'marketplaceDeliveryNotes';

  
  export const DELIVERY_NOTES_OVERVIEW = 'deliverynoteoverview';
  export const DELIVERY_NOTE = 'deliverynote';
  
  
  export interface DeliveryNoteState {
    [DELIVERY_NOTES_OVERVIEW]: {
      deliveryNotesOverview: DeliveryNotesOverview;
      isLoading: boolean;
      error?: Error;
    };
    [DELIVERY_NOTE]: {
      deliveryNote: DeliveryNote;
      isLoading: boolean;
      error?: Error;
    };
  }
  
  //******************************************************
  
  export const initialState: DeliveryNoteState = {
    [DELIVERY_NOTES_OVERVIEW]: {
        deliveryNotesOverview: null,
      isLoading: false,
      error: null,
    },
    [DELIVERY_NOTE]: {
      deliveryNote: null,
      isLoading: false,
      error: null,
    },
  };
  
  //******************************************************
  
  export const deliveryNoteReducer = createReducer(
    initialState,
    on(DeliveryNotesActions.getDeliveryNotesOverview, (state) => ({
      ...state,
      [DELIVERY_NOTES_OVERVIEW]: {
        deliveryNotesOverview: null,
        isLoading: true,
        error: null,
      },
    })),
    on(
      DeliveryNotesActions.getDeliveryNotesOverviewSuccess,
      (state, action) => ({
        ...state,
        [DELIVERY_NOTES_OVERVIEW]: {
          deliveryNotesOverview: action.overview,
          isLoading: false,
          error: null,
        },
      })
    ),
    on(
        DeliveryNotesActions.getDeliveryNotesOverviewFailure,
      (state, action) => ({
        ...state,
        [DELIVERY_NOTES_OVERVIEW]: {
          deliveryNotesOverview: null,
          isLoading: false,
          error: action.error,
        },
      })
    ),
    //******************************************************
    on(DeliveryNotesActions.getDeliveryNote, (state) => ({
      ...state,
      [DELIVERY_NOTE]: {
        deliveryNote: null,
        isLoading: true,
        error: null,
      },
    })),
    on(DeliveryNotesActions.getDeliveryNoteSuccess, (state, action) => ({
      ...state,
      [DELIVERY_NOTE]: {
        deliveryNote: action.deliveryNote,
        isLoading: false,
        error: null,
      },
    })),
    on(DeliveryNotesActions.getDeliveryNoteFailure, (state, action) => ({
      ...state,
      [DELIVERY_NOTE]: {
        deliveryNote: null,
        isLoading: false,
        error: action.error,
      },
    })),
    //******************************************************
    on(DeliveryNotesActions.clearDeliveryNotesOverview, (state, action) => ({
      ...state,
      [DELIVERY_NOTES_OVERVIEW]: {
        deliveryNotesOverview: null,
        isLoading: false,
        error: null,
      },
    })),
   );
  